// extracted by mini-css-extract-plugin
export default {"icon":"BalanceAction_icon__8qyRk"};